<template>
  <header class="management-section__header">
    <i
      v-if="icon"
      :class="[icon, 'management-section__icon', iconDanger ? 'management-section__icon--danger' : '']"
    />
    <h2 class="management-section__title">
      {{ title }}
      <span v-if="subtitle" class="management-section__subtitle">{{ subtitle }}</span>
    </h2>
    <div v-if="$slots.trailing" class="management-section__trailing">
      <slot name="trailing" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'ManagementSectionHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconDanger: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
@import './management-section.css';
</style>
